import React, { useEffect, useContext, useState, useRef } from "react";
import { Button, Input, Select, MapDemoContext } from "..";
import { Link } from "react-router-dom";
import "./demo-vrp-info.css";
import { getDemoById } from "../../list";

function DemoVRPInfo() {
  // const apiKeyInput = useRef(null);
  const rowsToAddEl = useRef(null);
  const savedFleetItemsEl = useRef(null);
  const demoName = window.location.pathname.split("/")[2];
  const demo = getDemoById(demoName);
  const demoData = demo.data;

  const getVehicleNameById = (id) => {
    return Object.entries(demoData.vehicles)[id][0]
  };
  
  const getVehicleIDByName = (name) => {
    return Object.entries(demoData.vehicles).findIndex(item => item[0] === name)
  };

  const getEmptyRow = () => {
    return (
      <div className="row" key={Math.floor(Math.random()*1000)}>
        <Select
          className="vehicle-type"
          placeholder={"* نوع ناوگان (ظرفیت)"}
          onChange={e => {
            setvalidateMessage("");
            // setMethod(e.target.value);
          }}
        >
          {/* {[...Object.keys(demoData.vehicles)]} */}
          {[...Object.entries(demoData.vehicles).map(([vehicle, vehicleDetails]) => `${vehicle} (${vehicleDetails.capacity[0]})`)]}
        </Select>
        <Input
          className="vehicle-name"
          placeholder={"نام ناوگان"}
          secondary
          onChange={e => {
            setvalidateMessage("");
          }}
        />
        <Input
          className="vehicle-count"
          placeholder={"* تعداد"}
          secondary
          onChange={e => {
            setvalidateMessage("");
          }}
        />
      </div>
    );
  };

  // const [method, setMethod] = useState("انتخاب روش ورود اطلاعات");
  const [validateMessage, setvalidateMessage] = useState("");
  const [rows, setRows] = useState([getEmptyRow()]);
  const [fleetItems, setFleetItems] = useState([]);

  const addToFleet = () => {
    setvalidateMessage("");
    let _rowsToAddEl = [...rowsToAddEl.current.childNodes];
    let  BreakException = {};
    let _fleetItems = []
    _rowsToAddEl.forEach(row => {
      let typeID = row.querySelector('.vehicle-type').value;
      let name = row.querySelector('.vehicle-name').childNodes[0].value;
      let count = window.toEnglishDigits(row.querySelector('.vehicle-count').childNodes[0].value);
      
      if (typeID && count) {
        if (!name) {
          let numberOfSameVehicleType = fleetItems.filter(i => i.typeID === typeID).length + 1;
          name = `${getVehicleNameById(typeID)}#${numberOfSameVehicleType}`;
        }

        _fleetItems.push({
          typeID,
          name,
          count,
        });
      }
      else if (typeID === '-1') {
        setvalidateMessage("لطفا نوع ناوگان را مشخص کنید.");
        throw BreakException;
      }
      else if (!count) {
        setvalidateMessage("لطفا تعداد ناوگان را مشخص کنید.");
        throw BreakException;
      }
    });

    if (_fleetItems.length === rows.length) {
      setFleetItems(fleetItems.concat(_fleetItems));
      setRows([getEmptyRow()]);
    }

  };

  const handleEditFleetItem = (e) => {
    let target = e.target;
    let targetItem = target.closest('.saved-fleets-list-item');
    if (targetItem.classList.contains('editing')) {
      targetItem.classList.remove('editing');
      let targetID = [...savedFleetItemsEl.current.childNodes].indexOf(targetItem);
      let _newFleetItems = fleetItems;
      _newFleetItems[targetID] = {
        typeID: getVehicleIDByName(targetItem.childNodes[1].firstElementChild.value),
        name: targetItem.childNodes[2].firstElementChild.value,
        count: targetItem.childNodes[3].firstElementChild.value,
      }
      setFleetItems(_newFleetItems);
    }
    else {
      targetItem.classList.add('editing');
      [2, 3].forEach(i => targetItem.childNodes[i].firstElementChild.readOnly = false);
    }

  };
  
  const handleDeleteFleetItem = (e) => {
    let target = e.target;
    let targetItem = target.closest('.saved-fleets-list-item');
    let targetID = [...savedFleetItemsEl.current.childNodes].indexOf(targetItem);
    let _newFleetItems = [...fleetItems];
    _newFleetItems.splice(targetID, 1);
    setFleetItems(_newFleetItems);
  };

  
  const {env} = useContext(MapDemoContext);
  useEffect(() => {
    if (env === 'development') {
      const form = document.querySelector(".form .row").childNodes;
      form[0].value = "2";
      form[2].querySelector("input").value = '10';
      let event = document.createEvent("HTMLEvents");
      event.initEvent("input", true, true);
      event.eventName = "input";
      form[2].querySelector("input").dispatchEvent(event);
    }
  }, [env])
  
  return (
    <MapDemoContext.Consumer>
      {({ setPage, setFleet, env }) => {
        let fleetItemsElements = fleetItems.map((fleetItem, idx) => {
          return (
            <div className="saved-fleets-list-item" key={idx}>
              <div className="fleet-item-index"></div>
              <div className="fleet-item-type"><input type="text" readOnly defaultValue={getVehicleNameById(fleetItem.typeID)}/></div>
              <div className="fleet-item-name"><input type="text" readOnly defaultValue={fleetItem.name}/></div>
              <div className="fleet-item-count"><input type="number" readOnly defaultValue={fleetItem.count}/></div>
              <div className="fleet-item-options">
                <span className="icon-pen" onClick={handleEditFleetItem}></span>
                <span className="icon-bin" onClick={handleDeleteFleetItem}></span>
              </div>
            </div> 
          );
        });

        let showFleetListsClass = fleetItems.length ? 'show-demo-details' : '';
        
        return (
          <div className={`demo-vrp-info ${showFleetListsClass}`}>
            <div className="mobile-view">
              <div className="mobile-view-bg"></div>
              <p>برای مشاهده راهکار به نسخه دسکتاپ سایت مراجعه فرمایید؛</p>
              <Link to={"/"}>
                <Button>بازگشت به صفحه اصلی</Button>
              </Link>
            </div>

            <div className="web-view">
              <div className="form">
                <h3>مشخصات ناوگان</h3>
                <div className="rows-wrapper" ref={rowsToAddEl}>
                  {rows}
                </div>
                <div className="add-row">
                  {/* <span
                    className="btn-add"
                    onClick={_ => {
                      setRows(rows.concat(getEmptyRow()));
                    }}
                  ></span> */}
                </div>
                <div className="save-buttons-wrapper">
                  <div className="save-options-wrapper">
                    <Button
                      className="btn-save"
                      secondary
                      onClick={addToFleet}
                    >
                      ذخیره ناوگان
                    </Button>
                    <span>{validateMessage}</span>                   
                  </div>
                </div>
              </div>
              <div className="vrp-fleets-detail">
                <div className="fleets-details-modal hide">
                  <div className="fleets-details-modal-list-wrapper">
                    <div className="saved-fleets-list" ref={savedFleetItemsEl}>
                      {fleetItemsElements}
                    </div>
                  </div>
                  <div className="save-and-go">
                    <p className="fleets-details">تعداد ناوگان ثبت‌شده: 
                      <span id="fleets-count">{fleetItems.length}</span>
                    </p>

                    <Button
                      className="btn-proceed"
                      primary
                      onClick={
                        () => {
                          setFleet(fleetItems);
                          setPage('MapDemo');
                        }
                      }
                    >
                      ثبت
                    </Button>
                    </div>
                  {/* <div className="fleets-details-modal-img"></div> */}
                </div>
              </div>
            </div>
            {/* <div className="fleets-details-modal-overlay">
            </div> */}
          </div>
        );
      }}
    </MapDemoContext.Consumer>
  );
}

export default DemoVRPInfo;
